import { TABULAR_SERVICE_FILLED_COLUMNS } from './contract'

const SERVICE_FILLED: ReadonlySet<string> = new Set(TABULAR_SERVICE_FILLED_COLUMNS)

/** Whether an agent run fills `column` from the page itself, so a reviewer cannot edit it. */
export function isTabularServiceFilledColumn(column: string): boolean {
  return SERVICE_FILLED.has(column)
}

/** What a reviewer's row edits on a held run's page change. */
export interface TabularEditCounts {
  /** Cells changed on stored rows. */
  changed: number
  added: number
  deleted: number
}

/** Edit counts as a phrase, "2 cells changed, 1 row added"; empty when there are none. */
export function tabularEditCountsText(counts: TabularEditCounts): string {
  return [
    counts.changed > 0 ? plural(counts.changed, 'cell changed', 'cells changed') : '',
    counts.added > 0 ? plural(counts.added, 'row added', 'rows added') : '',
    counts.deleted > 0 ? plural(counts.deleted, 'row deleted', 'rows deleted') : ''
  ]
    .filter(Boolean)
    .join(', ')
}

function plural(count: number, one: string, many: string): string {
  return `${count} ${count === 1 ? one : many}`
}
